// extracted by mini-css-extract-plugin
export default {"tag":"Chip_tag__tApde","overdue":"Chip_overdue__UNdKa"};